import { SET_FEATURE_FLAGS } from "../actions/featureFlags.actions";

const initialState = {};

const featureFlags = (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURE_FLAGS:
      return action.payload;

    default:
      return state;
  }
};

export default featureFlags;
